import FooterAllRights from '../FooterAllRights';
import FooterSmall from '../FooterSmall';
import { isSmallScreen } from '../ReactiveRender';

export default function ResponsiveFooter() {
  if (isSmallScreen()) {
    return <FooterSmall />;
  }
  return <FooterAllRights frame662Props={{}} />;
}
